import React from 'react';
import { HeroSection } from './components/HeroSection';
import { PainSection } from './components/PainSection';
import { SolutionSection } from './components/SolutionSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { CtaSection } from './components/CtaSection';
export function App() {
  return <main className="w-full min-h-screen bg-magi-cream overflow-x-hidden selection:bg-magi-brown selection:text-white" data-id="element-0">
      <HeroSection data-id="element-1" />
      <PainSection data-id="element-2" />
      <SolutionSection data-id="element-3" />
      <TestimonialsSection data-id="element-4" />
      <CtaSection data-id="element-5" />
    </main>;
}